import { toast } from "react-toastify"
import { sendGlobalMassage } from "../../services/tsQueryApis"

const SendGlobalMassage = ({ user }) => {
    return (
        <div className="mx-10">
            <ht3 className="mb-5">ارسال پیام همگانی:</ht3>
            <form
                onSubmit={(event) => {
                    event.preventDefault()
                    const form = new FormData(event.target)
                    const message = form.get("message")
                    toast
                        .promise(sendGlobalMassage(message), {
                            pending: "درحال ارسال پیام همگانی",
                            success: "ارسال داده شد",
                            error: "error",
                        })
                        .catch((err) => {
                            console.error(err)
                        })
                }}
            >
                <textarea type="text" name="message" id="message" class="styled-input" placeholder="پیام" required />
                <button type="submit" className="mt-5 styled-button px-4 py-2 border">
                    ارسال پیام
                </button>
            </form>
        </div>
    )
}

export default SendGlobalMassage
